export function directorySortName(person) {
  return person.nickname?.trim() || person.first_name?.trim() || person.name?.trim().split(/\s+/)[0] || "";
}

export function compareDirectoryPeople(left, right) {
  const options = { sensitivity: "base" };
  return directorySortName(left).localeCompare(directorySortName(right), undefined, options)
    || (left.last_name || left.name || "").localeCompare(right.last_name || right.name || "", undefined, options)
    || (left.name || "").localeCompare(right.name || "", undefined, options);
}

export function directoryPage(people, requestedPage) {
  const pageCount = Math.max(1, Math.ceil(people.length / 3));
  const page = Math.max(0, Math.min(requestedPage, pageCount - 1));
  return { page, pageCount, people: people.slice(page * 3, page * 3 + 3),
    start: people.length ? page * 3 + 1 : 0, end: Math.min(page * 3 + 3, people.length) };
}

export function directoryPageNumbers(page, count) {
  if (count <= 12) return Array.from({length:count}, (_, index) => index);
  const selected = new Set([0, count - 1, page - 2, page - 1, page, page + 1, page + 2]);
  const pages = [...selected].filter(value => value >= 0 && value < count).sort((a,b) => a-b);
  const result = [];
  pages.forEach((value,index) => { if(index && value-pages[index-1]>1) result.push(null); result.push(value); });
  return result;
}
